import { type QSetStatus, useGetQuestionUsageByIdQuery } from '@exam-management/graphql';
import {
  Flex,
  NoRowsOverlay,
  PaperSection,
  Text,
  DescriptionOutlinedIcon,
} from '@shared/components';

import { BaseQuestionUsageList, type QuestionUsage } from '../../components';

interface QContentQuestionUsageListProps {
  questionId: string;
}
export default function QContentQuestionUsageList(props: Readonly<QContentQuestionUsageListProps>) {
  const { questionId } = props;

  const { data: getQuestionUsageData, loading } = useGetQuestionUsageByIdQuery({
    variables: {
      questionId,
    },
  });

  const questionUsages = getQuestionUsageData?.qctGetQuestionUsageById ?? [];

  const rows: QuestionUsage[] = questionUsages
    .map((questionUsage) => ({
      id: questionUsage.qSetQuestionId,
      qSetCode: questionUsage.qSetCode,
      examCode: questionUsage.examCourseName,
      examCourse: questionUsage.examCourseCode,
      qConfigRefId: questionUsage.qConfigRefCode,
      questionNumber: questionUsage.qSetQuestionOrder,
      status: questionUsage.qSetStatus as QSetStatus,
    }))
    .sort((a, b) => a.qSetCode.localeCompare(b.qSetCode));
  return (
    <PaperSection title='Question Usage'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
          p: theme.spacing(6),
        })}
      >
        <Text variant='body1Semibold'>Total Usage: {rows.length} ชุด</Text>
        <BaseQuestionUsageList
          hideFooter
          rows={rows}
          loading={loading}
          slots={{
            noRowsOverlay: () => {
              return (
                <NoRowsOverlay
                  title='คำถามนี้ยังไม่ถูกนำไปใช้ในชุดข้อสอบ'
                  icon={DescriptionOutlinedIcon}
                  slotProps={{
                    wrapper: { disablePadding: true, sx: (theme) => ({ p: theme.spacing(20) }) },
                  }}
                />
              );
            },
          }}
        />
      </Flex>
    </PaperSection>
  );
}
